import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allMateriasAction, setActivoMateriasAction } from './MateriasAction';
import AsignarCarreras from './components/AsignarCarreras';
import FormMaterias from './components/FormMaterias';
import ListadoMaterias from './components/ListadoMaterias';

const MateriasView = () => {
  const dispatch = Redux.useDispatch();

  const materiasStore = Redux.useSelector((state) => state.materias);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoMateriasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
        />
        <BotonComponent
          click={async () => {
            await setActivoMateriasAction(dispatch, null);
            await allMateriasAction(dispatch, materiasStore.params);
          }}
          disabled={materiasStore.all.length === 0 || materiasStore.loadingAll}
          white
          refreshIcon
          text={materiasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoMaterias
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormMaterias"
        title={`${
          materiasStore.activo
            ? `Editar materia: ${materiasStore.activo.nombre}`
            : 'Nuevo materia'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {materiasStore.activo ? (
          <AsignarCarreras
            setOpenModalForm={(value) => setOpenModalForm(value)}
          />
        ) : (
          <FormMaterias
            activo={materiasStore.activo}
            setOpenModalForm={(value) => setOpenModalForm(value)}
          />
        )}
      </ModalComponent>
    </Grid>
  );
};

export default MateriasView;
